import { PageSkeleton } from './skeleton';

type LoadingStateProps = {
    /** @deprecated Preferir variant; mantido por compatibilidade */
    label?: string;
    variant?: 'page' | 'table' | 'cards' | 'detail' | 'dashboard' | 'inline';
    className?: string;
    count?: number;
};

/**
 * Loading padrao do v2: skeleton por blocos (nao spinner).
 */
export default function LoadingState({
    variant = 'page',
    className,
    count,
}: LoadingStateProps) {
    return <PageSkeleton variant={variant} className={className} count={count} />;
}
